/**
 * Page-specific words inside the shared calculator form card (BirthDetailsForm
 * and its BirthToolFormShell): submit labels, a tool's own time hint, and the
 * input errors a tool shows in the card.
 *
 * Hindi is native Hinglish (Roman), the same governed register as the card's
 * own labels in BirthDetailsForm.i18n.ts (rule 21). /hi/ pages used to pass
 * Devanagari submit labels and errors into that card, so one form read
 * "Janm tithi / Janm samay" over a Devanagari submit button (c-forms-10, b-calc-07).
 * Guarded by scripts/check_hindi_register.py (no Devanagari in this file) and
 * tests/calculator-form-register.test.ts (no Devanagari submit literal in any
 * page that renders the form).
 */
export const CALCULATOR_FORM_COPY = {
  rashi: {
    en: {
      submit: "Find My Rashi",
      // The shared hint names the Lagna, which a Moon-sign tool never shows.
      timeRequiredHint: "The Moon can change sign within a day — your exact time settles it.",
      timeRequired: "Exact birth time is required to calculate Moon sign and nakshatra.",
      placeRequired: "Select a birth city from the suggestions to calculate its coordinates.",
      failed: "Something went wrong",
      // The result reserve under the card repeats the error beside this button.
      calculating: "Calculating your Moon sign…",
      editDetails: "Edit birth details",
    },
    hi: {
      submit: "Apni rashi dekhein",
      timeRequiredHint:
        "Chandra ek din mein rashi badal sakta hai — exact samay se pakki rashi milti hai.",
      timeRequired: "Chandra rashi aur nakshatra ke liye exact janm samay zaroori hai.",
      placeRequired: "Coordinates ke liye suggestions mein se janm sthal chunein.",
      failed: "Calculation nahi ho payi — kripya dobara try karein.",
      calculating: "Aapki Chandra rashi calculate ho rahi hai…",
      editDetails: "Janm details badlein",
    },
  },
  ascendant: {
    en: { submit: "Find My Ascendant", failed: "Something went wrong" },
    hi: {
      submit: "Apna lagna dekhein",
      failed: "Calculation nahi ho payi — kripya dobara try karein.",
    },
  },
  nakshatra: {
    en: { submit: "Find My Nakshatra", failed: "Something went wrong" },
    hi: {
      submit: "Apna nakshatra dekhein",
      failed: "Calculation nahi ho payi — kripya dobara try karein.",
    },
  },
  remedies: {
    en: { submit: "Check My Remedies", failed: "Something went wrong" },
    hi: {
      submit: "Apne upay dekhein",
      failed: "Calculation nahi ho payi — kripya dobara try karein.",
    },
  },
} as const;
